import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Labels } from 'src/app/app.models';
import { BankAccountData, BankAccountMode } from '../bank-account.models';

@Component({
    selector: 'app-bank-account-select',
    templateUrl: './bank-account-select.component.html',
    styleUrls: ['./bank-account-select.component.scss'],
    standalone: false
})
export class BankAccountSelectComponent {
  @Output() public changeBankModeEvent: EventEmitter<BankAccountMode> = new EventEmitter<BankAccountMode>()
  @Output() public changeSelectedBankEvent: EventEmitter<any> = new EventEmitter<any>() // Todo: type
  @Output() public onContinueEvent: EventEmitter<void> = new EventEmitter<void>()
  
  @Input() labels: Labels
  @Input() optionConfig: any[] // Todo: type
  @Input() selectedBankAccount: any

  public emitBankModeChange(mode: BankAccountMode): void {
    this.changeBankModeEvent.emit(mode)
  }

  public emitChangeSelectedBank(selectedBankAccount: any): void { // Todo: type
    this.changeSelectedBankEvent.emit(selectedBankAccount)
  }

  public onContinue(): void {
    this.onContinueEvent.emit()
  }
}
